"use strict";

class yReader {
    constructor() {
        return function (name, type, y, $scope, onChangeFn, getYField) {

            if (getYField === true) {
                const interval = setInterval(() => {
                    const yField = y.get(name);
                    if (yField) {
                        clearInterval(interval);
                        this.initObserve(name, type, yField, $scope, onChangeFn);
                    }
                }, 100);
                return;
            }

            this.initObserve(name, type, y, $scope, onChangeFn);
        }.bind(this);
    }

    initObserve(name, type, y, $scope, onChangeFn) {
        let observer;
        switch (type) {
            case('y-text'):
                $scope[name] = y.toString();
                observer = this.getYTextObserver(name, $scope, onChangeFn);
                break;
            case('y-bool'):
                $scope[name] = this.toBool(y.toString());
                observer = this.getYBoolObserver(name, $scope, onChangeFn);
                break;
            case('text'):
                $scope[name] = y.get(name);
                observer = this.getTextObserver(name, $scope, onChangeFn);
                break;
            case('object'):
                $scope[name] = {};
                let keys = y.keys();
                for (let i = 0; i < keys.length; i++) {
                    $scope[name][keys[i]] = y.get(keys[i]);
                }
                $scope[name].$length = keys.length;

                observer = this.getYObjectObserver(name, $scope, onChangeFn);
        }

        y.observe(observer);

        $scope.$on('$destroy', () => {
            y.unobserve(observer);
        })
    }

    toBool(val) {
        return val == 'true' || val == 1;
    }


    getYTextObserver(name, $scope, onChangeFn) {
        let oldValue = '';
        return function (event) {

            const newValue = event.target.toString();

            if (newValue != '' && oldValue != newValue) {
                oldValue = newValue;

                $scope.$evalAsync(() => {
                    $scope[name] = newValue;

                    if (onChangeFn) {
                        onChangeFn(event);
                    }
                });
            }

        };
    }


    getYObjectObserver(name, $scope, onChangeFn) {
    	// @todo upgrade to the new yjs version. This does not work anymore
        return function (event) {
            if (event.type == 'add') {
                $scope.$evalAsync(() => {
                    $scope[name][event.name] = event.value;
                    $scope[name].$length++;
                });
            } else if (event.type == 'update') {
                $scope.$evalAsync(() => {
                    $scope[name][event.name] = event.value;
                });
            } else if (event.type == 'delete') {
                $scope.$evalAsync(() => {
                    delete $scope[name][event.name];
                    $scope[name].$length--;
                });
            }

            if (onChangeFn) {
                onChangeFn(event);
            }
        };
    }


    getYBoolObserver(name, $scope, onChangeFn) {
        let oldValue = '';
        return function (event) {

            const newValue = event.target.toString();

            if (newValue != '' && oldValue != newValue) {
                oldValue = newValue;

                $scope.$evalAsync(() => {
                    $scope[name] = this.toBool(event.target.toString());

                    if (onChangeFn) {
                        onChangeFn(event);
                    }
                });
            }

        }.bind(this);
    }


    getTextObserver(name, $scope, onChangeFn) {
        return function (event) {

			if (event.keysChanged.has(name)) {
                $scope.$evalAsync(() => {
                    $scope[name] = event.target.get(name);

                    if (onChangeFn) {
                        onChangeFn(event);
                    }
                });
            }
        };
    }
}

yReader.$inject = [];

module.exports = yReader;
